<script>
export default {
  name: 'FilterChips',
  props: {
    /** [{ key, label }] - one per active filter. */
    chips: { type: Array, default: () => [] },
  },
  emits: ['clear', 'clear-all'],
};
</script>

<template>
  <div v-if="chips.length" class="filter-chips">
    <button
      v-for="chip in chips"
      :key="chip.key"
      type="button"
      class="filter-chips__chip"
      :title="`Retirer le filtre ${chip.label}`"
      @click="$emit('clear', chip.key)"
    >
      {{ chip.label }}
      <i class="ri-close-line"></i>
    </button>

    <button
      type="button"
      class="filter-chips__clear-all"
      @click="$emit('clear-all')"
    >
      Tout effacer
    </button>
  </div>
</template>

<style scoped>
.filter-chips {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 20px 16px;
  flex-wrap: wrap;
}

.filter-chips__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 10px;
  background: #eef4fd;
  border: 1px solid #cfe0f8;
  border-radius: 999px;
  font-size: 12px;
  color: #00448c;
  cursor: pointer;
}

.filter-chips__chip:hover {
  background: #dcebfb;
}

.filter-chips__chip i {
  font-size: 13px;
  line-height: 1;
}

.filter-chips__clear-all {
  margin-left: 4px;
  border: 0;
  background: none;
  padding: 0;
  font-size: 12px;
  color: #6c757d;
  cursor: pointer;
}

.filter-chips__clear-all:hover {
  color: #212529;
  text-decoration: underline;
}
</style>
